import React, { useState } from 'react';
import './PillarCard.css';
import { pillarStep } from '../utils/convictionLabel';

// Collapsible grade-view pillar card used inside the expanded Screener/Portfolio
// rows: header shows the pillar score + a Favorable/Neutral/Cautious chip + a
// one-line "what this measures", and clicking drops down the individual tests
// (passed as children) — which keep their existing robust per-test descriptions.
const bandClass = (pct) => (pct >= 60 ? 'fav' : pct >= 40 ? 'neu' : 'cau');
const bandColor = (cls) => (cls === 'fav' ? '#2FD3A6' : cls === 'neu' ? '#F5B23B' : '#F87171');
// Strong / Mixed / Weak: "Favorable" is reserved for conviction 78+.
const bandWord = (cls) => pillarStep(cls === 'fav' ? 100 : cls === 'neu' ? 50 : 0).word;

const MEASURES = {
  Quality: 'The business itself — growth, margins, returns on capital, balance-sheet strength.',
  Setup: 'Technical timing — trend, momentum, relative strength, and volume.',
  Convex: 'Asymmetric upside — catalysts, demand/supply signals, and the valuation gap.',
  Macro: 'Market backdrop — liquidity, breadth, volatility, and sector leadership.',
};

export default function PillarCard({ name, score, max = 100, count, measures, children }) {
  const [open, setOpen] = useState(false);
  if (score == null || !isFinite(score)) return null;

  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const cls = bandClass(pct);
  const col = bandColor(cls);
  const disp = max === 100 ? Math.round(score) : Number(score).toFixed(1);

  return (
    <div className={`pcard${open ? ' is-open' : ''}`}>
      <button className="pcard-head" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <div className="pcard-top">
          <span className="pcard-name">{name}</span>
          <span className={`pcard-chip ${cls}`}>{bandWord(cls)}</span>
        </div>
        <div className="pcard-scorerow">
          <span className="pcard-score" style={{ color: col }}>{disp}</span>
          <span className="pcard-max">/ {max}</span>
          <span className="pcard-chev">{open ? '▾' : '▸'}</span>
        </div>
        <div className="pcard-track"><span className="pcard-fill" style={{ width: `${pct}%`, background: col }} /></div>
        <div className="pcard-measures">{measures || MEASURES[name] || ''}</div>
        <div className="pcard-more">{open ? 'Hide the tests ▾' : `See the ${count ? `${count} ` : ''}tests ▸`}</div>
      </button>
      {open && <div className="pcard-body">{children}</div>}
    </div>
  );
}
